import { BaseLogger } from '@wix/fedops-logger';
import { createContext, useContext } from 'react';

import { fedopsLogger } from '../../../util/renderModel';

export const FedopsLoggerContext = createContext<BaseLogger<string>>(fedopsLogger);
export const useFedopsLogger = () => useContext(FedopsLoggerContext);
